// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"294a063f","453":"62a06a3d"}[chunkId] + ".chunk.js";
};